import axios from "@/plugins/axios";

let url = "/api/v1/me/coupons";

export default {
    getCoupons(data){
        return axios.get(url, data).then(result => result.data);
    },
    postCoupon(data){
        return axios.post(url, data).then(result => result.data);
    },
}
